let data  =[
 
  {
    "id": 90101,
    "delivery_charges": 560,
    "city_english": "Rawalpindi",
    "name_english": "aroma bakers",
    "address_english": "Phase 8, bharia town",
    "name_urdu": "آروما بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "فیز 8، بحریہ ٹاؤن",
    "active": true,
    "whatApp": "https://chat.whatsapp.com/CjvX5VZqyHr6Z943AhrFZR"
  },
  {
    "id": 90102,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "falcon bakers",
    "address_english": "Scheme 3",
    "name_urdu": "فالکن بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "سکیم 3",
    "active": true,
    "whatApp": "https://chat.whatsapp.com/D2CdJLXV48BA0bZkPaKHXX"
  },
  {
    "id": 90103,
    "delivery_charges": 230,
    "city_english": "Islamabad",
    "name_english": "hafiz g bakers",
    "address_english": "PWD",
    "name_urdu": "حافظ جئی  بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "پی ڈبلیو ڈی",
    "active": true,
    "whatApp": "https://chat.whatsapp.com/L9W0keHLO3a27YTnLhtdhJ"
  },
  {
    "id": 90104,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "delight bakers",
    "address_english": "Gulraiz",
    "name_urdu": "ڈیلائیٹ بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "گلریز",
    "active": true,
    "whatApp": "https://chat.whatsapp.com/H64eUkPyubMDoUE4qtAaEs"
  },
  {
    "id": 90105,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "new ideal bakers",
    "address_english": "Bharia enclave",
    "name_urdu": "نیو آئیڈیل بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بحریہ انکلیو",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90106,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "sajawal bakers",
    "address_english": "Jinnah garder",
    "name_urdu": "سجاول بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "جناح گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90107,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "mr bakers",
    "address_english": "Swan garden",
    "name_urdu": "مسٹر بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سواں گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90108,
    "delivery_charges": 360,
    "city_english": "Islamabad",
    "name_english": "super ideal bakers",
    "address_english": "Banigala",
    "name_urdu": "سپر آئیڈیل بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بنی گالا",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90109,
    "delivery_charges": 260,
    "city_english": "Rawalpindi",
    "name_english": "cookies & crumbs",
    "address_english": "Phase 7, bharia town",
    "name_urdu": "کوکیز اینڈ کرومز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "فیز 7 بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90110,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "taste Londge",
    "address_english": "Swan garden",
    "name_urdu": "ٹیسٹ لاونج",
    "city_urdu": "راولپنڈی",
    "address_urdu": "فیز 8، بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90111,
    "delivery_charges": 310,
    "city_english": "Islamabad",
    "name_english": "salt & sweet",
    "address_english": "Bharia enclave",
    "name_urdu": "سالٹ اینڈ سویٹ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بحریہ انکلیو",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90112,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "sabziler",
    "address_english": "Morgah",
    "name_urdu": "سبزیلر",
    "city_urdu": "راولپنڈی",
    "address_urdu": "مورگاہ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90113,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "three star-burma",
    "address_english": "Burma stop khana pul",
    "name_urdu": "تھری سٹار- برما",
    "city_urdu": "اسلام آباد",
    "address_urdu": "برما سٹاپ کھنہ پل",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90114,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "PSO shop-phase 8",
    "address_english": "Phase 8, bharia town",
    "name_urdu": "پی ایس او شاپ- فیز8",
    "city_urdu": "راولپنڈی",
    "address_urdu": "فیز 8، بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90115,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "three star-Khana pul",
    "address_english": "Khanna pul",
    "name_urdu": "تھری سٹار- کھنہ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کھنہ پل",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90116,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "dua bakers",
    "address_english": "Humak",
    "name_urdu": "دعا بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ہمک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90117,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "ali bakers",
    "address_english": "Tramari",
    "name_urdu": "علی بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سواں گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90118,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "la carte",
    "address_english": "Swan garden",
    "name_urdu": "لا کارٹے",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سواں گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90119,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "morning basket",
    "address_english": "I-8",
    "name_urdu": "مارننگ باسکٹ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "آئی ایٹ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90120,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "international bakers-car chowk",
    "address_english": "car chowk",
    "name_urdu": "انٹرنیشنل بیکرز-کار چوک",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کار چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90121,
    "delivery_charges": 0,
    "city_english": "Islamabad",
    "name_english": "capital food",
    "address_english": "G 10",
    "name_urdu": "کیپٹل فوڈ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "جی- 10",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90122,
    "delivery_charges": 0,
    "city_english": "Islamabad",
    "name_english": "fair price shop",
    "address_english": "Khanna pul",
    "name_urdu": "فیئر پرائس شاپ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کھنہ پل",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90123,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "three star ghouri",
    "address_english": "Ghori garden",
    "name_urdu": "تھری سٹار غوری",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90124,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "Butter cup bakers",
    "address_english": "phase 6 bahria town",
    "name_urdu": "بٹر کپ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "فیز6، بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90125,
    "delivery_charges": 260,
    "city_english": "Islamabad",
    "name_english": "punjab sweets & bakers",
    "address_english": "Swan garden",
    "name_urdu": "پنجاب سویٹ اینڈ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سواں گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90126,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "bake & bakers",
    "address_english": "Swan garden",
    "name_urdu": "بیک اینڈ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سواں گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90127,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "jameel eggs",
    "address_english": "Ghori town",
    "name_urdu": "جمیل ایگز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90128,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "paradise bakers",
    "address_english": "paracha chowk",
    "name_urdu": "پردیسی بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "پراچہ چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90129,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "hafiz sweets & bakers",
    "address_english": "Thanda pani",
    "name_urdu": "حافظ سویٹ اینڈ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ٹھنڈا پانی",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90130,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "khawaja bakers",
    "address_english": "kurri road",
    "name_urdu": "خواجہ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کری روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90131,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "bait ul haleeb",
    "address_english": "police foundation",
    "name_urdu": "بیت الحلیب",
    "city_urdu": "اسلام آباد",
    "address_urdu": "پاکستان ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90132,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "al qaim bakers",
    "address_english": "pakistan town",
    "name_urdu": "القائم بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "پاکستان ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90133,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "rahat-B 17",
    "address_english": "B 17",
    "name_urdu": "راحت-بی17",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بی17",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90134,
    "delivery_charges": 100,
    "city_english": "Islamabad",
    "name_english": "bm milk shop",
    "address_english": "VIP ghouri town",
    "name_urdu": "بی ایم ملک شاپ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "وئی آئی پی غوری ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90135,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "rehmat bakers",
    "address_english": "Thanda pani",
    "name_urdu": "رحمت بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ٹھنڈاپانی",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90136,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "saif bakers",
    "address_english": "Karal chowk",
    "name_urdu": "سیف بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کورال چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90137,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "mister bakers",
    "address_english": "Phase 1, Bharia town",
    "name_urdu": "مسٹر بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "فیز 1، بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90138,
    "delivery_charges": 200,
    "city_english": "Islamabad",
    "name_english": "rahat-gt road",
    "address_english": "G T road swaan",
    "name_urdu": "راحت-جی ٹی روڈ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "جی ٹی روڈ سواں",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90139,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "city top bakers",
    "address_english": "Burma stop khana pul",
    "name_urdu": "سٹی ٹپ بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "برما سٹاپ کھنہ پل",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90140,
    "delivery_charges": 410,
    "city_english": "Rawalpindi",
    "name_english": "rc bakers",
    "address_english": "26 no chongi, Peshawar road",
    "name_urdu": "آر سی بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "26 نمبر چنگی ،پشاور روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90141,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "midway bakers",
    "address_english": "kurri road",
    "name_urdu": "مڈوے بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کری روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90142,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "shalimar bakers",
    "address_english": "kurri road",
    "name_urdu": "شالیمار بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کری روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90143,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "new khawaja bakers",
    "address_english": "Tramari chowk",
    "name_urdu": "نیو خواجہ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ترامڑی چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90144,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "abbasi bakers",
    "address_english": "kurri road",
    "name_urdu": "عباسی بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کری روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90145,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "al rehman bakers",
    "address_english": "kurri road",
    "name_urdu": "الرحمٰن  بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کری روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90146,
    "delivery_charges": 160,
    "city_english": "Islamabad",
    "name_english": "new broadway",
    "address_english": "Ghori garden",
    "name_urdu": "نیو براڈ وے",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری گارڈن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90147,
    "delivery_charges": 110,
    "city_english": "Rawalpindi",
    "name_english": "lasani bakers-kuri road",
    "address_english": "sadiqabad",
    "name_urdu": "لاثانی بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "صادق آباد",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90148,
    "delivery_charges": 250,
    "city_english": "Islamabad",
    "name_english": "elaf bakers",
    "address_english": "tramri chowk",
    "name_urdu": "ایلاف بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ترامڑی چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90149,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "al abbas bakers",
    "address_english": "Gulzar e qaid",
    "name_urdu": "العباس بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گلزار قائد",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90150,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "dawn bread",
    "address_english": "islamabad",
    "name_urdu": "دیوان بریڈ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "اسلام آباد",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90151,
    "delivery_charges": 260,
    "city_english": "Islamabad",
    "name_english": "kashmir bakers",
    "address_english": "bani gala",
    "name_urdu": "کشمیر بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بنی گالا",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90152,
    "delivery_charges": 310,
    "city_english": "Islamabad",
    "name_english": "sadeeque bakers",
    "address_english": "bani gala",
    "name_urdu": "صدیقی بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بنی گالا",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90153,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "shah e jilan",
    "address_english": "golra",
    "name_urdu": "شاہ جیلان",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گولڑہ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90154,
    "delivery_charges": 260,
    "city_english": "Islamabad",
    "name_english": "sitara sweet",
    "address_english": "G 7",
    "name_urdu": "ستارہ سویٹ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "جی  7",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90155,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "al safa",
    "address_english": "shehzad town",
    "name_urdu": "الصفا",
    "city_urdu": "اسلام آباد",
    "address_urdu": "شہزاد ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90156,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "international bakers-ghouri town",
    "address_english": "Ghori town",
    "name_urdu": "انٹرنیشنل-غوری",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90157,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "ss bakers",
    "address_english": "I 8",
    "name_urdu": "ایس ایس بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "آئی  8",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90158,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "maharaja bakers",
    "address_english": "Gulraiz",
    "name_urdu": "مہاراجہ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گلریز",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90159,
    "delivery_charges": 100,
    "city_english": "Islamabad",
    "name_english": "eatmore",
    "address_english": "Gulzar e qaid",
    "name_urdu": "ایٹ مور",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گلزار قائد",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90160,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "gujjar milk-shakrial",
    "address_english": "shakrial",
    "name_urdu": "گجر ملک شکریال",
    "city_urdu": "اسلام آباد",
    "address_urdu": "شکریال",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90161,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "gujjar milk-kurri road",
    "address_english": "kurri road",
    "name_urdu": "گجر ملک کری روڈ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کری روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90162,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "valley ways",
    "address_english": "Gulraiz",
    "name_urdu": "ویلی ویز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گلریز",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90163,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "king ned's",
    "address_english": "G 13",
    "name_urdu": "کنگ نیڈز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "جی  13",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90164,
    "delivery_charges": 360,
    "city_english": "Rawalpindi",
    "name_english": "ahmad bakers",
    "address_english": "cantt",
    "name_urdu": "احمد بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کینٹ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90165,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "bakeway-ghouri town",
    "address_english": "Ghori town",
    "name_urdu": "بیک وے-غوری",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90166,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "bakeway-khana road",
    "address_english": "jahaz ground",
    "name_urdu": "بیک و-کھنہ روڈ",
    "city_urdu": "راولپنڈی",
    "address_urdu": "جہاز گراؤنڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90167,
    "delivery_charges": 160,
    "city_english": "Islamabad",
    "name_english": "city bakers-ali pur",
    "address_english": "Alipur",
    "name_urdu": "سٹی بیکرز-علی پور",
    "city_urdu": "اسلام آباد",
    "address_urdu": "علی پور",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90168,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "cocoa bakers",
    "address_english": "bahria town",
    "name_urdu": "کوکا بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90169,
    "delivery_charges": 260,
    "city_english": "Islamabad",
    "name_english": "pak bakers",
    "address_english": "korang town",
    "name_urdu": "پاک بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کورنگ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90170,
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "mart & bakers",
    "address_english": "cannt",
    "name_urdu": "مارٹ اینڈ بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کینٹ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90171,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "sona bakers",
    "address_english": "Ghori town",
    "name_urdu": "سونا بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90172,
    "delivery_charges": 210,
    "city_english": "Islamabad",
    "name_english": "baker's Oven",
    "address_english": "behria town",
    "name_urdu": "بیکرز اوون",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بحریہ ٹاؤن",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90173,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "HD Bakers",
    "address_english": "shakrial",
    "name_urdu": "ایچ ڈی بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "شکریال",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90174,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "nilor factory",
    "address_english": "nilor",
    "name_urdu": "نیلور فیکٹری",
    "city_urdu": "اسلام آباد",
    "address_urdu": "نیلور",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90175,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "mcc-khana pul",
    "address_english": "Khanna pul",
    "name_urdu": "ایم سی سی- کھنہ پل",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کھنہ پل",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90176,
    "delivery_charges": 350,
    "city_english": "Islamabad",
    "name_english": "latif bakers",
    "address_english": "latrar road",
    "name_urdu": "لطیف بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "لہتراڑ روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90177,
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "premium milk",
    "address_english": "Gulzar e qaid",
    "name_urdu": "پریمیم میلک",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گلزار و قائد",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90178,
    "delivery_charges": 360,
    "city_english": "Rawalpindi",
    "name_english": "rahat-commeti chowk",
    "address_english": "commeti chowk",
    "name_urdu": "راحت-کمیٹی چوک",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کمیٹی چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90179,
    "delivery_charges": 475,
    "city_english": "Rawalpindi",
    "name_english": "rahat-chohr chowk",
    "address_english": "chohr chowk",
    "name_urdu": "راحت-چوڑ چوک",
    "city_urdu": "راولپنڈی",
    "address_urdu": "چوڑ چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90180,
    "delivery_charges": 160,
    "city_english": "Islamabad",
    "name_english": "lasani bakers-terlai",
    "address_english": "terlai chowk",
    "name_urdu": "لاثانی بیکرز-ترلائی",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ترلائی چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90181,
    "delivery_charges": 110,
    "city_english": "Islamabad",
    "name_english": "city bakers-terlai",
    "address_english": "terlai chowk",
    "name_urdu": "سٹی بیکرز-ترلائی",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ترلائی چوک",
    "active": true,
    "whatApp": ""
  },
  {
    "id": 90182,
    "delivery_charges": 410,
    "city_english": "Islamabad",
    "name_english": "Asan mart",
    "address_english": "simli dam road",
    "name_urdu": "آسان مارٹ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سملی ڈیم روڈ",
    "active": true,
    "whatApp": ""
  },
  {
    "id": "9QdkT3CUJWYxtRz3pevq",
    "delivery_charges": 290,
    "city_english": "rawalpindi",
    "name_english": "al noor sweets & bakers",
    "address_english": "holy family rawalpindi",
    "name_urdu": "النور سویٹ اینڈ بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "ہولی فیملی راولپنڈی",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "A6ZHtp3v0ZuVKjD1ep5t",
    "delivery_charges": 110,
    "city_english": "islamabad",
    "name_english": "link bakers",
    "address_english": "ghouri town phase 5",
    "name_urdu": "لنک بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری ٹاون فیز ۵",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "BUyENIhAdpk1KBTC3gs2",
    "delivery_charges": 440,
    "city_english": "Islamabad",
    "name_english": "Ideal Mart",
    "address_english": "Al-Zaraj near GigaMall",
    "name_urdu": "آئیڈیل مارٹ",
    "city_urdu": "Islamabad",
    "address_urdu": "Al-Zaraj near GigaMall",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "EqGuFb0eDEiW81ArxdOk",
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "M Milk Shop",
    "address_english": "khanna",
    "name_urdu": "‍ایم ملک شاپ",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کھنہ",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "HGC609v7pnUwllXPz52l",
    "delivery_charges": 480,
    "city_english": "rawalpindi",
    "name_english": "cakes & bread",
    "address_english": "ratta amral rwp",
    "name_urdu": "کیکس اینڈ بریڈ",
    "city_urdu": "راولپنڈی",
    "address_urdu": "رتا امرال راولپنڈی",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "KpVb2rsbn6PH2zJkswS4",
    "delivery_charges": 250,
    "city_english": "islamabad",
    "name_english": "shireen Mahal-PWD",
    "address_english": "PWD",
    "name_urdu": "شیریں محل- پی ڈبلیو ڈی",
    "city_urdu": "اسلام آباد",
    "address_urdu": "پی ڈبلیو ڈی",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "KxWvYq9shMjJ8A5Fplov",
    "delivery_charges": 210,
    "city_english": "Islamabad",
    "name_english": "Rumi bakers",
    "address_english": "PWD",
    "name_urdu": "رومی بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "پی ڈبلیو ڈی",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "L8hj15GUWUF4dMJHNF9e",
    "delivery_charges": 10,
    "city_english": "islamabad",
    "name_english": "ali general store",
    "address_english": "sitara market islamabad",
    "name_urdu": "علی جنرل سٹور",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ستارہ مارکیٹ اسلام آباد",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "Rj9JF6KRSdSiExvTSgRN",
    "delivery_charges": 12,
    "city_english": "aa",
    "name_english": "tested2",
    "address_english": "a",
    "name_urdu": "ss",
    "city_urdu": "aaaa",
    "address_urdu": "s",
    "active": "",
    "whatApp": 22
  },
  {
    "id": "SP4yJPF2MGXq5ZlIT6vF",
    "delivery_charges": 10,
    "city_english": "islamabad",
    "name_english": "Bake-1",
    "address_english": "Bahria Phase-2",
    "name_urdu": "بیک ون",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بحریہ فیز 2",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "SnQ2latnnKE7IEs2YHRi",
    "delivery_charges": 280,
    "city_english": "Islamabad",
    "name_english": "Moroccan bakers",
    "address_english": "",
    "name_urdu": "موروکن بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "گلبرگ گرین",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "T3aXRaY4THGwBZf9Svl5",
    "delivery_charges": 500,
    "city_english": "islamabad",
    "name_english": "Organics G-8",
    "address_english": "G-8 Islamabad",
    "name_urdu": "اورگینک جی۔8",
    "city_urdu": "اسلام آباد",
    "address_urdu": "جی۔8 اسلام آباد",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "UqwCIABYreHl6EPfg7IO",
    "delivery_charges": 0,
    "city_english": "islamabad",
    "name_english": "Shafiq supplier",
    "address_english": "ghouri vip",
    "name_urdu": "شفیق سپلائر",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری وی آئی پی",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "VmXGETttVUCsraHNzkfG",
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "royal bakers",
    "address_english": "Banigala",
    "name_urdu": "رائلز بیکرز",
    "city_urdu": "",
    "address_urdu": 2,
    "active": "",
    "whatApp": ""
  },
  {
    "id": "WwScPEODwuyJIOnxw26H",
    "delivery_charges": 110,
    "city_english": "islamabad",
    "name_english": "tayyab bakers",
    "address_english": "ghouri vip",
    "name_urdu": "طیب بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "غوری وی آئی پی",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "ZkWNQtkXANfd0V69le62",
    "delivery_charges": 2010,
    "city_english": "",
    "name_english": "sammar bakers",
    "address_english": "Chakwal road, mandra",
    "name_urdu": "ثمر بیکرز",
    "city_urdu": "",
    "address_urdu": "",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "anKydXQH2aSfm1zjKQRd",
    "delivery_charges": "",
    "city_english": "",
    "name_english": "",
    "address_english": "",
    "name_urdu": "",
    "city_urdu": "",
    "address_urdu": "",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "biFqQACIYu441lzSB5to",
    "delivery_charges": 110,
    "city_english": "Rawalpindi",
    "name_english": "Yousaf Bakers",
    "address_english": "Gharibabad",
    "name_urdu": "يوسف بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "غریب آباد",
    "active": "",
    "whatApp": "03054191155"
  },
  {
    "id": "eiQuZvECbpkBVE0wBxRo",
    "delivery_charges": 210,
    "city_english": "islamabad",
    "name_english": "Gulshan Sweets and bakers",
    "address_english": "scheme iii",
    "name_urdu": "گلشن سویٹس اینڈ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "سکیم تھری",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "f9qX8HUrelcfcT3VcuFn",
    "delivery_charges": 160,
    "city_english": "rawalpindi",
    "name_english": "shireen bakers",
    "address_english": "khana pull",
    "name_urdu": "شیریں بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "کھنہ پل",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "gKx0CiendFTJrDDr69Pv",
    "delivery_charges": 10,
    "city_english": "islamabad",
    "name_english": "Saqib Supplier",
    "address_english": "burma town",
    "name_urdu": "ثاقب سپلائر",
    "city_urdu": "اسلام آباد",
    "address_urdu": "برما ٹاون",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "iZpnB13DZdVP3rsGB94p",
    "delivery_charges": 10,
    "city_english": "Islamabad",
    "name_english": "Cake pop bakers",
    "address_english": "T .chowk",
    "name_urdu": "کیک پوپ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "ٹی چوک روات اسلام آباد",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "jdAlCYYks6ZRl8VmGGq1",
    "delivery_charges": 160,
    "city_english": "rawalpindi",
    "name_english": "ayan bakers",
    "address_english": "scheme-iii",
    "name_urdu": "آیان بیکرز",
    "city_urdu": "راولپنڈی",
    "address_urdu": "سکیم تھری",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "q5wlUxwBUoROdZghUSlN",
    "delivery_charges": 10,
    "city_english": "islamabad",
    "name_english": "shabir rusk supplier",
    "address_english": "islamabad",
    "name_urdu": "شبیر  رس سپلائرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کھنہ پل",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "qX1nJauyacihet1k5NyK",
    "delivery_charges": 110,
    "city_english": "islamabad",
    "name_english": "zest  delight",
    "address_english": "burma  islamabad",
    "name_urdu": "زیسٹ دیلاہیٹ",
    "city_urdu": "اسلام آباد",
    "address_urdu": "برما اسلا م آباد",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "xopDtUV6EMCgyQvfBIg5",
    "delivery_charges": 10,
    "city_english": "islamabad",
    "name_english": "shabir ruslk supplier",
    "address_english": "islamabad",
    "name_urdu": "",
    "city_urdu": "اسلام آباد",
    "address_urdu": "کھنہ پل",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "zLGpimossgODb74tRqW0",
    "delivery_charges": 600,
    "city_english": "islamabad",
    "name_english": "new sadeeq sweets and bakers",
    "address_english": "bahria enclave",
    "name_urdu": "نیو صدیق سویٹس اینڈ بیکرز",
    "city_urdu": "اسلام آباد",
    "address_urdu": "بحریہ انکلیو",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "1rhhIMRqILpcNa3RG6tD",
    "delivery_charges": 160,
    "city_english": "islamabad",
    "name_english": "chakwal milk shop",
    "address_english": "ghouri town phase 5",
    "name_urdu": "ٌچکوال میلک",
    "city_urdu": "",
    "address_urdu": "",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "2nrLa8fArnTfKqlyh9c7",
    "delivery_charges": 110,
    "city_english": "rawalpindi",
    "name_english": "gujjar bakers fazaiya",
    "address_english": "fazaiya shaheen town",
    "name_urdu": "گجر بیکرز فضاءیہ",
    "city_urdu": "راولپنڈی",
    "address_urdu": "فضاءیہ شاہین ٹاون",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "4CMbIbulu39whbETVgox",
    "delivery_charges": 10,
    "city_english": "islamabad",
    "name_english": "grains(D17)",
    "address_english": "D17",
    "name_urdu": "گرینر(دی17)",
    "city_urdu": "اسلام آباد",
    "address_urdu": "دی17",
    "active": "",
    "whatApp": ""
  },
  {
    "id": "7TGlmt4GCXsCzoAqQpZ9",
    "delivery_charges": 10,
    "city_english": "Rawalpindi",
    "name_english": "Gur Cheeni",
    "address_english": "Adyala Road",
    "name_urdu": "گڑ چینی",
    "city_urdu": "راولپنڈی",
    "address_urdu": "‍ڈیالہ روڈ",
    "active": "",
    "whatApp": ""
  }
]
export default data;